import { Col, Row, theme } from 'antd';
import React from 'react';
import styles from './styles.module.scss';

const style: React.CSSProperties = { margin: '10px' };

const EmployeeListHeader: React.FC = (): JSX.Element => {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <>
      <Row className={styles.row}>
        <Col span={6}>
          <div style={{ marginTop: '22px', marginLeft: '15px' }}>
            <p className={styles['col-name']}>
              <b>Name</b>
            </p>
          </div>
        </Col>
        <Col span={4}>
          <div style={{ marginTop: '22px' }}>
            <p className={styles['col-name']}>
              <b>Designation</b>
            </p>
          </div>
        </Col>
        <Col span={2}>
          <div style={{ marginTop: '22px' }}>
            <p className={styles['col-name']}>
              <b>Total Experience</b>
            </p>
          </div>
        </Col>
        <Col span={2}>
          <div style={{ marginTop: '22px' }}>
            <p className={styles['col-name']}>
              <b>Client Engaged</b>
            </p>
          </div>
        </Col>
        <Col span={6}>
          <div style={{ marginTop: '22px' }}>
            <p className={styles['col-name']}>
              <b>Skills</b>
            </p>
          </div>
        </Col>
        <Col span={3}>
          <div style={{ marginTop: '22px' }}>
            <p className={styles['col-name']}>
              <b>Status</b>
            </p>
          </div>
        </Col>
        <Col span={1}>
          <div style={{ marginTop: '22px' }}>
            <p className={styles['col-name']}>
              <b>Action</b>
            </p>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default EmployeeListHeader;
